import React, { useState } from 'react';
import {
  Box,
  Typography,
  CircularProgress,
  IconButton,
  Dialog,
  DialogContent,
  useMediaQuery,
  Tooltip,
} from '@mui/material';
import { Close, PlayCircleOutline } from '@mui/icons-material';
import { useGetLinkPreviewQuery } from '../feedbackApiSlice';
import blocked from '../../../assets/blocked.png';
import { SkeletonLinkPreview } from '../skeletons/SkeletonLinkPreview';

const LinkPreview = ({ feedback }) => {
  const [open, setOpen] = useState(false);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const links = feedback.feedbackText.match(
    /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi
  );
  const urlCheck = links && links[0];
  let url = urlCheck?.endsWith('"') ? urlCheck.slice(0, -1) : urlCheck;
  url = url?.replace('<br>', '');
  const {
    data: linkPreview,
    error,
    isLoading,
  } = useGetLinkPreviewQuery(url, {
    skip: !url,
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (!url || !urlCheck) {
    return null;
  }

  if (isLoading) {
    return <SkeletonLinkPreview />;
  }
  const videoUrl = linkPreview?.videos ? linkPreview?.videos[0]?.url : null;

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'flex-end',
        }}
      >
        {videoUrl && !isMobile ? (
          <IconButton
            onClick={handleClickOpen}
            sx={{
              position: 'absolute',
              left: 'calc(355px)',
              zIndex: 1,
            }}
          >
            <PlayCircleOutline />
          </IconButton>
        ) : null}
        <Box
          sx={{
            mb: 1,
            border: '1px solid #ddd',
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
            width: isMobile ? '65vw' : '300px',
          }}
        >
          <a href={url} target="_blank" rel="noopener noreferrer" className="attachment-link">
            {linkPreview?.images ? (
              <img
                src={linkPreview?.images[0] || linkPreview?.favicons[0] || null}
                alt={linkPreview?.title}
                style={{ width: '100%', height: '150px', objectFit: 'contain' }}
              />
            ) : (
              <img src={blocked} alt={'Not Found'} style={{ width: '100%', height: '150px', objectFit: 'contain' }} />
            )}
          </a>
          <Box sx={{ padding: '8px' }}>
            <Tooltip title={linkPreview?.description}>
              <a href={url} target="_blank" rel="noopener noreferrer" className="attachment-link">
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  {linkPreview?.title || 'This site is Blocked'}
                </Typography>
              </a>
            </Tooltip>
          </Box>
        </Box>
        <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
          <DialogContent sx={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <IconButton onClick={handleClose} sx={{ position: 'absolute', top: '0px', right: '0px', color: 'white' }}>
              <Close />
            </IconButton>

            <Box sx={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
              <iframe
                src={videoUrl}
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
                title="video"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '98%',
                  height: '98%',
                  background: 'transparent',
                }}
              />
            </Box>
          </DialogContent>
        </Dialog>
      </Box>
    </>
  );
};

export default LinkPreview;
